import React, { memo } from 'react';
import PageHeader from '../components/PageHeader';
import ImageWithFallback from '../components/ImageWithFallback';
import { CheckCircle, Users, Calendar, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
const Private = () => {
  const benefits = ['Customized itineraries tailored to your preferences', 'Flexible scheduling to accommodate your timeline', 'Private transportation throughout your journey', 'Dedicated guides providing personalized attention', 'Exclusive access to select attractions and experiences', 'Premium accommodations with special amenities', 'Halal dining options at quality restaurants'];
  const experiences = [{
    title: 'Family Umrah Experience',
    image: 'https://images.unsplash.com/photo-1591221668516-0d6c8c7eb11b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    description: 'A private Umrah journey designed specifically for families, with child-friendly accommodations and experiences.',
    features: ['Family-friendly accommodations', 'Kid-focused educational activities', 'Flexible pace for children and elderly']
  }, {
    title: 'Luxury Heritage Tour',
    image: 'https://images.unsplash.com/photo-1563911302283-d2bc129e7570?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    description: 'Explore historical sites with expert guides in the comfort of luxury transportation and premium accommodations.',
    features: ['5-star accommodations', 'Private guided tours', 'Exclusive cultural experiences']
  }, {
    title: 'VIP Honeymoon Package',
    image: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    description: 'Create unforgettable memories with our specially designed honeymoon packages for newlyweds.',
    features: ['Romantic dining experiences', "Couples' activities", 'Private transportation']
  }];
  return <div className="w-full" data-id="element-898">
      <PageHeader title="Private Tours" subtitle="Exclusive travel experiences designed just for you" backgroundImage="https://images.unsplash.com/photo-1503220317375-aaad61436b1b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" data-id="element-899" />
      {/* Introduction */}
      <section className="py-16 bg-white" data-id="element-900">
        <div className="container mx-auto px-4 md:px-8" data-id="element-901">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-902">
            <div data-id="element-903">
              <h2 className="text-3xl font-bold text-navy-900 mb-6" data-id="element-904">
                Personalized Travel Experiences
              </h2>
              <p className="text-navy-700 text-lg mb-6" data-id="element-905">
                Our private tours offer the ultimate in personalized travel
                experiences. Whether you're traveling with family, friends, or
                as a couple, we'll create a custom itinerary that meets your
                specific needs and interests.
              </p>
              <p className="text-navy-700 text-lg mb-8" data-id="element-906">
                With dedicated guides, private transportation, and flexible
                scheduling, you'll enjoy the freedom to explore at your own pace
                while receiving the attentive service that Kembara Ustaz is
                known for.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-907">
                <Link to="/contact" className="bg-gold-500 hover:bg-gold-600 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-908">
                  Inquire Now
                </Link>
                <Link to="/packages" className="bg-transparent border-2 border-navy-900 hover:bg-navy-900 hover:text-white text-navy-900 px-8 py-3 rounded-md font-medium transition-colors" data-id="element-909">
                  View Sample Itineraries
                </Link>
              </div>
            </div>
            <div className="relative" data-id="element-910">
              <ImageWithFallback src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1421&q=80" alt="Private Travel Experience" className="rounded-lg shadow-lg" data-id="element-911" />
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-navy-900 rounded-lg -z-10" data-id="element-912"></div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits */}
      <section className="py-16 bg-navy-50" data-id="element-913">
        <div className="container mx-auto px-4 md:px-8" data-id="element-914">
          <h2 className="text-3xl font-bold text-center text-navy-900 mb-12" data-id="element-915">
            Benefits of Private Tours
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-12" data-id="element-916">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start" data-id="element-917">
                <CheckCircle size={24} className="text-gold-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-918" />
                <p className="text-navy-700" data-id="element-919">{benefit}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Featured Experiences */}
      <section className="py-16 bg-white" data-id="element-920">
        <div className="container mx-auto px-4 md:px-8" data-id="element-921">
          <h2 className="text-3xl font-bold text-center text-navy-900 mb-12" data-id="element-922">
            Featured Private Experiences
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-923">
            {experiences.map((experience, index) => <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-924">
                <div className="h-48" data-id="element-925">
                  <ImageWithFallback src={experience.image} alt={experience.title} className="w-full h-full object-cover" data-id="element-926" />
                </div>
                <div className="p-6" data-id="element-927">
                  <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-928">
                    {experience.title}
                  </h3>
                  <p className="text-navy-700 mb-4" data-id="element-929">{experience.description}</p>
                  <ul className="mb-6" data-id="element-930">
                    {experience.features.map((feature, i) => <li key={i} className="flex items-center mb-2" data-id="element-931">
                        <CheckCircle size={16} className="text-gold-500 mr-2" data-id="element-932" />
                        <span className="text-sm text-navy-700" data-id="element-933">{feature}</span>
                      </li>)}
                  </ul>
                  <Link to="/contact" className="block text-center bg-navy-900 hover:bg-navy-800 text-white py-2 rounded font-medium transition-colors" data-id="element-934">
                    Get a Quote
                  </Link>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* How It Works */}
      <section className="py-16 bg-navy-900 text-white" data-id="element-935">
        <div className="container mx-auto px-4 md:px-8" data-id="element-936">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-937">How It Works</h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-938">
            <div className="text-center" data-id="element-939">
              <div className="w-16 h-16 bg-navy-800 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-940">
                <Phone size={32} className="text-gold-500" data-id="element-941" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-942">
                1. Initial Consultation
              </h3>
              <p className="text-gray-300" data-id="element-943">
                Contact us to discuss your travel preferences, dates, and
                special requirements.
              </p>
            </div>
            <div className="text-center" data-id="element-944">
              <div className="w-16 h-16 bg-navy-800 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-945">
                <MapPin size={32} className="text-gold-500" data-id="element-946" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-947">2. Custom Itinerary</h3>
              <p className="text-gray-300" data-id="element-948">
                We'll create a tailored itinerary based on your preferences and
                budget.
              </p>
            </div>
            <div className="text-center" data-id="element-949">
              <div className="w-16 h-16 bg-navy-800 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-950">
                <Calendar size={32} className="text-gold-500" data-id="element-951" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-952">3. Confirmation</h3>
              <p className="text-gray-300" data-id="element-953">
                Review the proposal, make adjustments, and confirm your booking.
              </p>
            </div>
            <div className="text-center" data-id="element-954">
              <div className="w-16 h-16 bg-navy-800 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-955">
                <Users size={32} className="text-gold-500" data-id="element-956" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-957">4. Enjoy Your Journey</h3>
              <p className="text-gray-300" data-id="element-958">
                Relax and enjoy your personalized travel experience with our
                dedicated support.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Contact CTA */}
      <section className="py-16 bg-gold-500 text-white" data-id="element-959">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-960">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-961">
            Ready to Plan Your Private Tour?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto" data-id="element-962">
            Contact our specialists today to start planning your personalized
            travel experience.
          </p>
          <Link to="/contact" className="bg-white text-navy-900 hover:bg-navy-50 px-8 py-3 rounded-md font-medium transition-colors inline-block" data-id="element-963">
            Contact Us Now
          </Link>
        </div>
      </section>
    </div>;
};
export default Private;